module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/19.f7334340.jpg";